import React from 'react'

export interface IOwnProps extends google.maps.MarkerOptions {
  infoWindow?: google.maps.InfoWindow
}
export interface IStateProps {  }
export interface IDispatchProps { }

export type IProps = IOwnProps & IStateProps & IDispatchProps

const Marker: React.FC<IProps> = (props) => {
  const [marker, setMarker] = React.useState<google.maps.Marker>()
  const {infoWindow,...rest} = props
  React.useEffect(() => {
    if (!marker) {
      setMarker(new google.maps.Marker())
    }

    // remove marker from map on unmount
    return () => {
      if (marker) {
        marker.setMap(null)
      }
    }
  }, [marker])

  React.useEffect(() => {
    if (marker) {
      marker.setOptions(rest)
      if (infoWindow && rest.title) {
        marker.addListener('click', () => {
          infoWindow.close()
          infoWindow.setContent(marker.getTitle())
          infoWindow.open(marker.getMap(), marker)
        })
      }
    }
  }, [infoWindow, marker, rest])

  return null
}

export default Marker
